import { StyledMods } from '@styled-kit/mods';
import styled, { css } from 'styled-components';

import { Button } from '../Button/Button';

export const StyledButton = styled(Button)<
    StyledMods<{ backgroundImage: string; backgroundImageHover: string; height: number; width: number }>
>`
    background-repeat: no-repeat;
    background-position: center;

    ${({ $backgroundImage, $backgroundImageHover, $height, $width }) => css`
        height: ${$height}px;
        width: ${$width}px;
        background-image: url(${$backgroundImage});
        &:hover {
            background-image: url(${$backgroundImageHover});
        }
    `}
`;
